// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"f9bcff73","732":"f510f926","779":"ca83ef80","891":"e707917d"}[chunkId] + ".chunk.css";
};